import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { Checkbox } from "../Checkbox";

type Option = { label: string; value: string | number }[];

export interface StaticOptionsListFilterProps extends ColumnFilterProps {
  options: Option;
}

export const StaticOptionsListFilter: React.FC<StaticOptionsListFilterProps> = ({
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
  options,
}) => {
  const dispatch = useDispatch();
  const value = [
    ...((useSelector((state: RootState) => filterSelectorValue(state, fieldName))?.value as (string | number)[]) ?? []),
  ];

  return (
    <>
      {options.map((option) => (
        <div key={option.value}>
          <Checkbox
            checked={value.includes(option.value)}
            onChange={() => {
              if (!value.includes(option.value)) {
                value.push(option.value);
              } else {
                value.splice(value.indexOf(option.value), 1);
              }
              dispatch(
                filterUpdateAction({ id: fieldName, name: fieldName, operator: FilterOperator.IsAnyOf, value: value })
              );
            }}
          />
          {option.label}
        </div>
      ))}
    </>
  );
};
